import { Box, Button, IconButton, Paper, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';

type UploadPhotoFormProps = {
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleRemovePhoto: (index: number) => void;
  files?: File[];
  filesError?: string;
};

const UploadPhotoForm: React.FC<UploadPhotoFormProps> = (props) => {
  return (
    <>
      <Box
        display="flex"
        gap={1}
        sx={{
          overflowX: 'auto',
          padding: '0px',
          maxWidth: {
            md: '100%',
            xs: '65vw',
          },
        }}
      >
        <Button
          variant="outlined"
          component="label"
          sx={{
            width: '100px',
            height: '100px',
            minWidth: 'unset',
            display: 'flex',
            flexShrink: 0,
            justifyContent: 'center',
            alignItems: 'center',
            border: '1.5px dotted blue',
          }}
        >
          <AddIcon />
          <input type="file" accept="image/*" multiple hidden onChange={props.handleFileChange} />
        </Button>

        {!!props.files?.length &&
          props.files.map((photo, index) => (
            <Box key={index} position="relative">
              <Paper
                elevation={3}
                sx={{
                  width: '100px',
                  height: '100px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={URL.createObjectURL(photo)}
                  alt="Uploaded"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </Paper>
              <IconButton
                size="small"
                onClick={() => props.handleRemovePhoto(index)}
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  padding: '0px',
                  background: 'rgba(255, 255, 255, 0.8)',
                  '&:hover': {
                    background: 'rgba(255, 255, 255, 1)',
                  },
                }}
              >
                <CancelIcon sx={{ margin: '0px', padding: '0px' }} fontSize="small" />
              </IconButton>
            </Box>
          ))}
      </Box>
      {props.filesError && (
        <Typography variant="body2" color="error">
          {props.filesError}
        </Typography>
      )}
    </>
  );
};

export default UploadPhotoForm;
